module.exports = __webpack_public_path__ + "img/adult-intermediate.01c55764.jpg";